import React, { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

/**
 * Cheats Portal Modal — shown when the user triggers the secret version
 * tap Easter Egg (7 taps on the version number in under 4 seconds).
 *
 * Passwords handled by the parent via `onSubmit(password)`.
 */
export function CheatsPortalModal({ isOpen, onClose, onSubmit }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Reset state whenever the modal is re-opened.
  useEffect(() => {
    if (isOpen) {
      setPassword('');
      setError('');
    }
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = password.trim();
    if (!trimmed) {
      setError('Enter a password');
      return;
    }
    const accepted = onSubmit(trimmed);
    if (accepted) {
      onClose();
    } else {
      setError('Incorrect password');
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent
        className="sm:max-w-md w-[calc(100vw-1rem)] max-w-[calc(100vw-1rem)] sm:w-auto"
        data-testid="cheats-portal-modal"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl">
            <Sparkles className="h-5 w-5 text-yellow-500" />
            WOW
          </DialogTitle>
          <DialogDescription className="pt-2 space-y-1 text-sm">
            <span className="block">You found the Cheats Portal</span>
            <span className="block">Go ahead and try Cheats</span>
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-3">
          <Input
            type="password"
            autoFocus
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            placeholder="Enter password"
            data-testid="cheats-portal-password-input"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
          />
          {error && (
            <p
              className="text-xs text-destructive"
              data-testid="cheats-portal-error"
            >
              {error}
            </p>
          )}

          <DialogFooter className="flex-row justify-end gap-2 sm:gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              data-testid="cheats-portal-cancel-btn"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-testid="cheats-portal-submit-btn"
            >
              Submit
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default CheatsPortalModal;
